<template>
    <div class="flex flex-col flex-1">
        <question-header :question="question" :instructions="instructions" :required="required"/>

        <div class="flex flex-col flex-1">
            <div class="flex flex-col flex-1 justify-center">
                <div class="custom-select relative w-full bg-light-200 rounded-full">
                    <select v-model="value"
                            class="w-full focus:outline-none text-lightGrey-300 font-bold cursor-pointer py-1 sm:py-2 md:py-4 pl-3 md:pl-6 pr-12">
                        <template v-for="(option, index) in localeOptions">
                            <option v-if="option"
                                    :key="index"
                                    :value="index"
                            >{{ option }}
                            </option>
                        </template>
                    </select>
                </div>
            </div>

            <div v-if="errorMessage"
                 class="w-full py-1 sm:py-2 md:py-3 pl-6 mt-8 md:mt-12 bg-risk-400 rounded-full text-center text-base md:text-2xl text-light-100">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
    import { locale } from '../../data/locale';
    import QuestionHeader from './QuestionHeader';

    export default {
        components: {
            QuestionHeader
        },
        props: {
            question: {
                type: Object,
                required: true
            },
            options: {
                type: Array,
                required: true,
            },
            required: {
                type: Boolean,
                required: true
            },
            instructions: Object,
            answer: Array
        },
        data() {
            return {
                value: 0,
                errorMessage: null,
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(index) {
                    const answers = [{
                        index,
                        value: this.$options.filters.trans(this.options[index])
                    }];

                    this.$emit('input', answers);
                }
            }
        },
        computed: {
            localeOptions() {
                return this.options.filter(option => option).map(option => option[locale()]);
            },
        },
        methods: {
            validate() {
                return {
                    valid: true
                }
            }
        },
        mounted() {
            if (this.answer[0]) {
                this.value = this.answer[0].index;
            }
        }
    }
</script>
